/* Brandon's way homepage behaviour (2026-10-09). Film hero, reveal on scroll, product track, formula tabs, scene films.
   Everything degrades: without JS the page is complete and still. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Reveal on scroll */
  if ('IntersectionObserver' in window && !reduce.matches) {
    root.classList.add('bw-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('bw-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-bw-reveal]').forEach(function (el) { io.observe(el); });
    var showAll = function () { document.querySelectorAll('[data-bw-reveal]').forEach(function (el) { el.classList.add('bw-in'); }); };
    window.addEventListener('load', function () { setTimeout(showAll, 2500); });
    setTimeout(showAll, 5000);
  }

  /* Hero film */
  var hero = document.querySelector('[data-bw-hero]');
  if (hero) {
    /* Header is see-through while the film is under it */
    var overHero = function () {
      var headerH = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 100;
      document.body.classList.toggle('bw-over-hero', window.scrollY < hero.offsetHeight - headerH);
    };
    overHero();
    window.addEventListener('scroll', overHero, { passive: true });
    window.addEventListener('resize', overHero);
    var video = hero.querySelector('[data-bw-hero-video]');
    var control = hero.querySelector('[data-bw-hero-play]');
    var hint = hero.querySelector('[data-bw-hero-hint]');
    var bar = hero.querySelector('[data-bw-hero-progress]');
    var small = window.matchMedia('(max-width: 749px)').matches;
    var src = small ? video.getAttribute('data-src-phone') : video.getAttribute('data-src-desktop');
    var poster = small ? video.getAttribute('data-poster-phone') : video.getAttribute('data-poster-desktop');
    if (poster) video.poster = poster;
    var userPaused = false;
    var icon = function (name) {
      return name === 'pause'
        ? '<svg class="bw-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 5v14M16 5v14"/></svg>'
        : '<svg class="bw-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m8 4 12 8-12 8Z"/></svg>';
    };
    var label = function () {
      if (!control) return;
      control.innerHTML = icon(video.paused ? 'play' : 'pause') + '<span>' + (video.paused ? 'Enter the moment' : 'Pause the moment') + '</span>';
      control.setAttribute('aria-label', video.paused ? 'Play the film' : 'Pause the film');
      control.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
    };
    var play = function () { var p = video.play(); if (p && p.catch) p.catch(function () {}); };
    if (src && !video.getAttribute('src')) video.setAttribute('src', src);
    if (reduce.matches) { userPaused = true; if (hint) hint.textContent = 'Motion is off for your preferences'; }
    else if (small && hint) { hint.textContent = 'Tap to pause'; }
    if (control) control.addEventListener('click', function () {
      if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
      label();
    });
    video.addEventListener('play', label);
    video.addEventListener('pause', label);
    video.addEventListener('timeupdate', function () {
      if (bar) bar.style.width = (video.duration ? video.currentTime / video.duration * 100 : 0) + '%';
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) video.pause(); else if (!userPaused) play(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { if (!userPaused) play(); } else { video.pause(); } });
      }, { threshold: 0.2 }).observe(hero);
    } else if (!userPaused) { play(); }
    label();
  }

  /* Clean header: the Bag label and count open the drawer too, and the count follows cart updates */
  document.querySelectorAll('.bw-header__bag--drawer').forEach(function (wrap) {
    var trigger = wrap.querySelector('cart-drawer-component > button');
    wrap.addEventListener('click', function (e) { if (trigger && !trigger.contains(e.target)) trigger.click(); });
    var count = wrap.querySelector('.bw-header__count');
    document.addEventListener('cart:update', function (e) {
      var n = e && e.detail && e.detail.data && e.detail.data.itemCount;
      if (count && typeof n === 'number') count.textContent = n;
    });
  });

  /* Clean header: phone menu */
  var menuBtn = document.querySelector('[data-bw-menu-button]');
  var mobileNav = document.querySelector('[data-bw-mobile-nav]');
  if (menuBtn && mobileNav) {
    var setMenu = function (open) {
      mobileNav.hidden = !open;
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('bw-menu-open', open);
      if (open) { var first = mobileNav.querySelector('a, button'); if (first) first.focus(); } else { menuBtn.focus(); }
    };
    menuBtn.addEventListener('click', function () { setMenu(mobileNav.hidden); });
    var closeBtn = mobileNav.querySelector('[data-bw-menu-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mobileNav.hidden) setMenu(false); });
  }

  /* Shop menu in the clean header */
  var shopBtn = document.querySelector('[data-bw-shop-button]');
  var shopPanel = document.querySelector('[data-bw-shop-panel]');
  if (shopBtn && shopPanel) {
    var setShop = function (open) { shopPanel.hidden = !open; shopBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); };
    shopBtn.addEventListener('click', function () { setShop(shopPanel.hidden); });
    document.addEventListener('click', function (e) { if (!shopPanel.hidden && !shopPanel.contains(e.target) && e.target !== shopBtn && !shopBtn.contains(e.target)) setShop(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !shopPanel.hidden) { setShop(false); shopBtn.focus(); } });
    document.addEventListener('focusin', function (e) { var h = shopBtn.closest('.bw-header'); if (!shopPanel.hidden && h && !h.contains(e.target)) setShop(false); });
  }

  /* Product track arrows */
  document.querySelectorAll('[data-bw-track]').forEach(function (track) {
    var parent = track.closest('section') || document;
    parent.querySelectorAll('[data-bw-track-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.querySelector('.bw-card');
        var step = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
        track.scrollBy({ left: step * Number(btn.getAttribute('data-bw-track-dir')), behavior: reduce.matches ? 'auto' : 'smooth' });
      });
    });
  });

  /* Formula tabs */
  document.querySelectorAll('[data-bw-tabs]').forEach(function (wrap) {
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(wrap.querySelectorAll('[role="tabpanel"]'));
    var select = function (i, focus) {
      tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); t.tabIndex = n === i ? 0 : -1; });
      panels.forEach(function (p, n) { p.hidden = n !== i; });
      if (focus) tabs[i].focus();
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = i;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        else return;
        e.preventDefault(); select(n, true);
      });
    });
  });

  /* Scene films: load on demand, explicit play, pause off screen */
  document.querySelectorAll('[data-bw-film]').forEach(function (fig) {
    var v = fig.querySelector('video');
    var b = fig.querySelector('[data-bw-film-play]');
    if (!v) return;
    var manual = false;
    var load = function () { if (!v.getAttribute('src') && v.getAttribute('data-src')) v.setAttribute('src', v.getAttribute('data-src')); };
    var setLabel = function () {
      if (!b) return;
      b.setAttribute('aria-pressed', v.paused ? 'false' : 'true');
      var t = b.querySelector('span'); if (t) t.textContent = v.paused ? 'Play film' : 'Pause film';
    };
    if (b) b.addEventListener('click', function () {
      load();
      if (v.paused) { manual = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { manual = false; v.pause(); }
      setLabel();
    });
    v.addEventListener('play', setLabel); v.addEventListener('pause', setLabel);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { load(); if (!reduce.matches && !manual) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
          else { v.pause(); }
        });
      }, { threshold: 0.35 }).observe(fig);
    }
  });
})();
